import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { buscarTraslados, getTrasladosSearchModel } from "../../../../../actions/traslados";
import BuscarTramosContainerPT from "./pt/buscarTramosContainerPT";
import { convertDateTimeToNet } from "../../../../../utils/datetimeUtils";
import FormContainer from "../../../forms/formContainer";
import BuscarTrasladosTable from "./buscarTrasladosTable";
import {
  openFptDuplicateFromTraslado,
  openFptEditableFromTraslado,
  openFptFromTraslado,
  openFptReadOnlyFromTraslado,
} from "../trasladosVisualizarUtils";
import snackbarUtils from "../../../../../utils/snackbarUtils";

const initialFilters = {
  PrestadorId: "",
  PrestadorTrasladoId: "",
  NroSiniestro: "",
  DocumentoTrabajador: "",
  Trabajador: "",
  EstadoTramoId: "",
  FechaDesde: null,
  FechaHasta: null,
  ProvinciaOrigen: "",
  LocalidadOrigen: "",
  ProvinciaDestino: "",
  LocalidadDestino: "",
  AgenciaId: "",
  Gestor: "",
  NroTraslado: "",
  NroTramoUnico: "",
  Sentido: "Todos",
  TipoTransporteId: "",
  BuscarSobreRecorridoCompleto: false,
};

const BuscarTrasladosContainer = () => {
  const dispatch = useDispatch();
  const artContext = useSelector((state) => ({
    idArt:
      state.auth.artAsociada?.id ||
      state.arts.artPrestadores?.data?.[0]?.arts?.[0]?.id,
    artName:
      state.auth.artAsociada?.nombre ||
      state.arts.artPrestadores?.data?.[0]?.arts?.[0]?.nombre,
  }));
  const roles = useSelector((state) => state.auth.roles);
  const isGestorSiniestros = Boolean(roles.GESTORSINIESTROS);
  const isAgenteTraslados = Boolean(roles.AGENTETRASLADOS);
  const isPrestadorTraslado = Boolean(roles.PRESTADORTRASLADO);
  const busquedaState = useSelector((state) => state.traslados.busqueda) || {
    isFetching: false,
    data: [],
  };

  const soloGS = isGestorSiniestros && !isAgenteTraslados;
  const [filters, setFilters] = useState(initialFilters);

  useEffect(() => {
    if (!isPrestadorTraslado) {
      dispatch(getTrasladosSearchModel());
    }
  }, [dispatch, isPrestadorTraslado]);

  const handleSearch = (values) => {
    const searchValues = values || filters;
    setFilters(searchValues);
    const payload = { ...searchValues };

    if (payload.Sentido === "Todos") payload.EsRetorno = null;
    else if (payload.Sentido === "Ida") payload.EsRetorno = false;
    else if (payload.Sentido === "Vuelta") payload.EsRetorno = true;
    delete payload.Sentido;

    payload.FechaDesde = convertDateTimeToNet(payload.FechaDesde);
    payload.FechaHasta = convertDateTimeToNet(payload.FechaHasta);

    for (let key in payload) {
      if (payload[key] === "") payload[key] = null;
    }

    dispatch(buscarTraslados(payload));
  };

  const handleClear = () => {
    setFilters(initialFilters);
  };

  const handleVisualizarTraslado = (traslado) => {
    openFptFromTraslado(dispatch, traslado, openFptReadOnlyFromTraslado, artContext);
  };

  const handleEditarTraslado = (traslado) => {
    openFptFromTraslado(dispatch, traslado, openFptEditableFromTraslado, artContext);
  };

  const handleAgregarTramo = (traslado) => {
    openFptFromTraslado(dispatch, traslado, openFptEditableFromTraslado, artContext);
  };

  const handleDuplicarTraslado = (traslado) => {
    if (traslado?.siniestroEsRechazado) {
      snackbarUtils.error("El siniestro se encuentra rechazado. No puede solicitar traslado.");
      return;
    }
    if (traslado?.siniestroTieneAltaMedica) {
      snackbarUtils.error("El siniestro tiene alta médica. No puede solicitar traslado.");
      return;
    }
    openFptFromTraslado(dispatch, traslado, openFptDuplicateFromTraslado, artContext);
  };

  if (isPrestadorTraslado) {
    return <BuscarTramosContainerPT />;
  }

  return (
    <>
      <BuscarTrasladosTable
        filters={filters}
        onSearch={handleSearch}
        onClear={handleClear}
        results={busquedaState.data || []}
        isFetching={busquedaState.isFetching}
        soloGS={soloGS}
        canManageTraslados={isAgenteTraslados}
        onViewTraslado={handleVisualizarTraslado}
        onEditTraslado={handleEditarTraslado}
        onAddTramo={handleAgregarTramo}
        onDuplicateTraslado={handleDuplicarTraslado}
        onAssignAgencia={(_, traslado) => handleEditarTraslado(traslado)}
      />
      <FormContainer />
    </>
  );
};

export default BuscarTrasladosContainer;
